// Pure geometry for the RadialFab rotary-dial menu.
// The arc is CENTERED on the up-left diagonal (225deg) and spans `arcSpan`
// degrees, so spoke i sits at:
//   theta = (225 - arcSpan / 2) + (i / (count - 1)) * arcSpan
// in standard math convention (the convention Math.cos/Math.sin use).
//   x = radius * cos(theta), y = radius * sin(theta)
// For arcSpan=120 the arc runs theta = 165deg .. 285deg:
//   165deg -> down-and-left   (x<0, y>0)
//   225deg -> straight up-left (x<0, y<0)  -- arc midpoint
//   285deg -> up-and-right    (x>0, y<0)
// Offsets are applied directly as CSS `translate(x, y)` — CSS +y is
// downward, so a negative y moves the spoke up. Do NOT negate y.
//
// NOTE: with the arc dipping below horizontal and past vertical, the FAB
// must be lifted off the page corner (see radialFab.css) so no spoke clips.

const DEG2RAD = Math.PI / 180

export function computeSpokeOffsets (count, arcSpan, radius) {
  if (!count || count < 1) return []
  const start = 225 - arcSpan / 2
  if (count === 1) {
    const theta = 225 * DEG2RAD // single spoke on the up-left diagonal
    return [{ x: radius * Math.cos(theta), y: radius * Math.sin(theta) }]
  }
  const offsets = []
  for (let i = 0; i < count; i++) {
    const theta = (start + (i / (count - 1)) * arcSpan) * DEG2RAD
    offsets.push({ x: radius * Math.cos(theta), y: radius * Math.sin(theta) })
  }
  return offsets
}
